import {inject, Injectable} from '@angular/core';
import {AuthService} from "../auth/auth.service";
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {Observable} from "rxjs";
import {map, tap} from "rxjs/operators";

@Injectable(
  {
    providedIn: 'root'
  }
)
export class AuthGuardService {
  readonly #router: Router = inject(Router);
  readonly #authService: AuthService = inject(AuthService)


  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.#authService.user$.pipe(
      map((user) => user !== undefined),
      tap((isLogged: boolean) => {
        if (!isLogged) void this.#router.navigate(['/login'])
      })
    )
  }
}
